/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useAppSelector } from 'src/hooks';
import Storage from 'src/utils/storage/storage';
import './legends.scss';
import { Grid, Skeleton, Typography } from '@mui/material';

export default function PHLegends() {
  // getting the ph recommendation map config data from local storage (as it will be accessible on refresh as well)
  const phRecommendationConfig = Storage.getPhRecommendationLegend();

  //   getting keys of phRecommendationConfig in sorted order
  const phRecommendationConfigKeys = Object.keys(phRecommendationConfig)?.sort(
    (a, b) => phRecommendationConfig[a].order - phRecommendationConfig[b].order
  );

  const legendStyle = (currColor) => ({
    height: '10px',
    width: '10px',
    margin: '4px',
    backgroundColor: currColor
  });

  return (
    <>
      {phRecommendationConfigKeys ? (
        <Grid
          container
          display='flex'
          alignItems='baseline'
          flexDirection='column'
        >
          <Grid item xs='auto' sx={{ margin: 'auto' }}>
            <Typography
              fontSize='10px'
              component='div'
              fontWeight='bold'
              marginLeft='3px'
            >
              PH Recommendation Legend
            </Typography>
          </Grid>
          <Grid ml={1} container item xs='auto' alignItems='center'>
            {phRecommendationConfigKeys.map((phRecommObj,i) => (
                <Grid key={i} item xs='auto' sx={{ margin: '0px 4px' }}>
                  <Typography
                    fontSize='10px'
                    component='div'
                    fontWeight='bold'
                    color={phRecommendationConfig[phRecommObj].color}
                  >
                    {phRecommendationConfig[phRecommObj].alias}{' '}
                  </Typography>
                </Grid>
            ))}
          </Grid>
        </Grid>
      ) : (
        ''
      )}
    </>
  );
}
